import React from 'react'

const Login = () => {
  return (
    <div>This is going to be hard....</div>
  )
}

export default Login